module.exports = __webpack_public_path__ + "img/menu.9bcf5497.png";